import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Icon from "@mui/material/Icon";

import styles from "./InfoArea.module.scss";

export default function InfoAreaTribalism({
  icon,
  title, 
  description, 
  iconColor = "gray", 
  vertical = false, 
  className 
}) {
  const IconComponent = icon;
  const iconWrapper = classNames(
    styles.iconWrapper,
    styles[iconColor],
    { [styles.iconWrapperVertical]: vertical }
  );
  const iconClasses = classNames(styles.icon, {
    [styles.iconVertical]: vertical
  });
  const infoAreaClasses = classNames(styles.infoArea, className);
  let iconElement = null;
  switch (typeof icon) {
    case "string":
      iconElement = <Icon className={iconClasses}>{icon}</Icon>;
      break;
    default:
      iconElement = IconComponent ? (
        <IconComponent className={iconClasses} />
      ) : null;
      break;
  }
  return (
    <div className={infoAreaClasses}>
      <div className={iconWrapper}>{iconElement}</div>
      <div className={styles.descriptionWrapper}>
        <h4 className={styles.title}>{title}</h4>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
}

InfoAreaTribalism.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  iconColor: PropTypes.oneOf([
    "primary",
    "warning",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  vertical: PropTypes.bool,
  className: PropTypes.string
};